module.exports = __webpack_public_path__ + "img/search.93b16cd.png";